export const LOAD_DEPOSIT_STATUS = 'LOAD_DEPOSIT_STATUS'
export const LOAD_DEPOSITS = 'LOAD_DEPOSITS'
export const UPDATE_DEPOSIT_STATUS = 'UPDATE_DEPOSIT_STATUS'